export default __webpack_public_path__ + "static/media/close-btn.0a505112.svg";